import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Car, Calendar, User } from 'lucide-react';

const MobileBottomNav = () => {
  const location = useLocation();
  const [isPWA, setIsPWA] = useState(false);
  
  useEffect(() => {
    // Check if running as installed PWA (standalone mode)
    const checkPWAMode = () => {
      const isStandalone = window.matchMedia('(display-mode: standalone)').matches 
        || window.navigator.standalone === true  // iOS Safari
        || document.referrer.includes('android-app://'); // Android TWA
      
      setIsPWA(isStandalone);
    };
    
    checkPWAMode();
    
    // Listen for display mode changes
    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    const handler = (e) => setIsPWA(e.matches);
    mediaQuery.addEventListener('change', handler);
    
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);
  
  const navItems = [
    { path: '/garage', icon: Car, label: 'Garage' },
    { path: '/booking', icon: Calendar, label: 'Book' },
    { path: '/profile', icon: User, label: 'Profile' }
  ];

  // ONLY show when running as installed PWA, NOT in browser
  if (!isPWA) {
    return null;
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 safe-area-bottom">
      <div className="flex items-center justify-around h-16 pb-safe">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors relative ${
                isActive 
                  ? 'text-blue-600' 
                  : 'text-gray-500 hover:text-blue-500'
              }`}
              data-testid={`mobile-nav-${item.label.toLowerCase()}`}
            >
              {isActive && (
                <div className="absolute top-0 w-12 h-0.5 bg-blue-600 rounded-full" />
              )}
              <Icon className={`h-6 w-6 ${isActive ? 'stroke-[2.5px]' : ''}`} />
              <span className={`text-xs mt-1 ${isActive ? 'font-semibold' : 'font-medium'}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
